import React from "react";

// Soft luxury placeholder for cards without an image yet.
// Pure CSS — no external assets.
export const ImagePlaceholder = ({ label = "Foto in arrivo", className = "" }) => (
  <div
    aria-hidden="true"
    className={`relative w-full h-full flex flex-col items-center justify-center bg-gradient-to-br from-[#F7F4EE] via-[#F4F4F4] to-[#EAE3D2] text-[#9A7B3E] ${className}`}
  >
    <svg
      viewBox="0 0 64 80"
      className="w-12 h-14 md:w-14 md:h-16 opacity-60"
      fill="none"
      stroke="currentColor"
      strokeWidth="1"
    >
      <path d="M22 6h20v8h-20z" />
      <path d="M16 18 h32 v54 a4 4 0 0 1 -4 4 h-24 a4 4 0 0 1 -4 -4 z" />
      <path d="M22 30 h20 M22 42 h20" strokeOpacity="0.4" />
    </svg>
    <div className="mt-4 uppercase tracking-[0.32em] text-[10px] opacity-70">
      {label}
    </div>
  </div>
);

export default ImagePlaceholder;
